package streetlight.model.data

enum class ResourceType {
    FoodAssistance,
    Shelter,
    Medical,
    Bathroom,
    Water,
    Shower,
    Laundry,
    Storage,
    GoodVibes,
}